var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelchairInaccessibleOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.25,
    stroke: "#D02525",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.728 5.883a1.35 1.35 0 100-2.701 1.35 1.35 0 000 2.701zM14.455 9.874a.655.655 0 00-.568-.648c-1.485-.223-2.336-1.378-3.052-2.161-.858-.966-2.458-.46-2.458.925v3.971c0 .743.608 1.35 1.35 1.35h3.377v2.702c0 .372.304.676.676.676a.677.677 0 00.675-.676v-3.039c0-.743-.608-1.35-1.35-1.35h-2.027v-2.33a6.084 6.084 0 002.573 1.229.663.663 0 00.804-.649zm-4.167 4.113a2.029 2.029 0 01-1.911 1.35 2.023 2.023 0 01-2.026-2.025c0-.885.567-1.628 1.35-1.911v-1.398a3.377 3.377 0 103.985 3.984h-1.398z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D02525",
    strokeWidth: 1.5,
    d: "M3.703 3.551l13.182 12.728"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairInaccessibleOutline);
export default __webpack_public_path__ + "static/media/wheelchair-inaccessible-outline.3f274689.svg";
export { ForwardRef as ReactComponent };